/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCouponDefinitionListDTO } from '../dto';
// @ts-ignore
import type { CouponBudgetOrderWithTenantListDTO } from '../dto';
// @ts-ignore
import type { CouponBudgetOrdersDTO } from '../dto';
// @ts-ignore
import type { CouponDefinitionDTO } from '../dto';
// @ts-ignore
import type { CouponDefinitionListDTO } from '../dto';
// @ts-ignore
import type { CouponGiftDTO } from '../dto';
// @ts-ignore
import type { CouponGiftListDTO } from '../dto';
// @ts-ignore
import type { CouponGiftOccasionListDTO } from '../dto';
// @ts-ignore
import type { CouponGiftWithEmployeeListDTO } from '../dto';
// @ts-ignore
import type { CouponOrderDTO } from '../dto';
// @ts-ignore
import type { CouponOrderListDTO } from '../dto';
// @ts-ignore
import type { CouponOrderStatus } from '../dto';
// @ts-ignore
import type { CouponOrderWithEmployeeListDTO } from '../dto';
// @ts-ignore
import type { CouponOrdersStatisticDTO } from '../dto';
// @ts-ignore
import type { CouponTransactionsHistoryDTO } from '../dto';
// @ts-ignore
import type { CreateCouponBudgetOrderDTO } from '../dto';
// @ts-ignore
import type { CreateCouponGiftDTO } from '../dto';
// @ts-ignore
import type { CreateCouponOrderDTO } from '../dto';
// @ts-ignore
import type { IdentifierDTO } from '../dto';
// @ts-ignore
import type { SaveGiftOccasionDTO } from '../dto';
// @ts-ignore
import type { UpdateCouponBudgetOrderDTO } from '../dto';
// @ts-ignore
import type { UpdateCouponDefinitionDTO } from '../dto';
// @ts-ignore
import type { UpdateCouponGiftDTO } from '../dto';
// @ts-ignore
import type { UpdateCouponOrderDTO } from '../dto';
// @ts-ignore
import type { UpdateEmployeeCouponDefaultDTO } from '../dto';
// @ts-ignore
import type { ValidationErrorResponseDTO } from '../dto';
/**
 * CouponsApi - axios parameter creator
 * @export
 */
export const CouponsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary cancels a pending coupon order
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCouponOrder: async (tenantId: string, employeeId: string, couponOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('cancelCouponOrder', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('cancelCouponOrder', 'employeeId', employeeId)
            // verify required parameter 'couponOrderId' is not null or undefined
            assertParamExists('cancelCouponOrder', 'couponOrderId', couponOrderId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders/{couponOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponOrderId"}}`, encodeURIComponent(String(couponOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary places a coupon budget order
         * @param {string} tenantId 
         * @param {CreateCouponBudgetOrderDTO} createCouponBudgetOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBudgetOrder: async (tenantId: string, createCouponBudgetOrderDTO: CreateCouponBudgetOrderDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createBudgetOrder', 'tenantId', tenantId)
            // verify required parameter 'createCouponBudgetOrderDTO' is not null or undefined
            assertParamExists('createBudgetOrder', 'createCouponBudgetOrderDTO', createCouponBudgetOrderDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/budgetOrders`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponBudgetOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateCouponGiftDTO} createCouponGiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouponGift: async (tenantId: string, employeeId: string, createCouponGiftDTO: CreateCouponGiftDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createCouponGift', 'employeeId', employeeId)
            // verify required parameter 'createCouponGiftDTO' is not null or undefined
            assertParamExists('createCouponGift', 'createCouponGiftDTO', createCouponGiftDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/gifts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponGiftDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates a coupon order for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateCouponOrderDTO} createCouponOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouponOrder: async (tenantId: string, employeeId: string, createCouponOrderDTO: CreateCouponOrderDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createCouponOrder', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createCouponOrder', 'employeeId', employeeId)
            // verify required parameter 'createCouponOrderDTO' is not null or undefined
            assertParamExists('createCouponOrder', 'createCouponOrderDTO', createCouponOrderDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deletes a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponGiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouponGift: async (tenantId: string, employeeId: string, couponGiftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponGiftId' is not null or undefined
            assertParamExists('deleteCouponGift', 'couponGiftId', couponGiftId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/gifts/{couponGiftId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponGiftId"}}`, encodeURIComponent(String(couponGiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns the whole transaction history list in CSV format
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {boolean} [includeCouponOrders] 
         * @param {boolean} [includeGiftOrders] 
         * @param {boolean} [includeBudgetOrders] 
         * @param {boolean} [includeIncentiveOrders] 
         * @param {boolean} [includeBudgetCorrections] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTransactionHistory: async (tenantId: string, month?: string, includeCouponOrders?: boolean, includeGiftOrders?: boolean, includeBudgetOrders?: boolean, includeIncentiveOrders?: boolean, includeBudgetCorrections?: boolean, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportTransactionHistory', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/transactionHistory/export`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (includeCouponOrders !== undefined) {
                localVarQueryParameter['includeCouponOrders'] = includeCouponOrders;
            }

            if (includeGiftOrders !== undefined) {
                localVarQueryParameter['includeGiftOrders'] = includeGiftOrders;
            }

            if (includeBudgetOrders !== undefined) {
                localVarQueryParameter['includeBudgetOrders'] = includeBudgetOrders;
            }

            if (includeIncentiveOrders !== undefined) {
                localVarQueryParameter['includeIncentiveOrders'] = includeIncentiveOrders;
            }

            if (includeBudgetCorrections !== undefined) {
                localVarQueryParameter['includeBudgetCorrections'] = includeBudgetCorrections;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns all coupons in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdminCouponDefinitions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/coupons/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns all coupons that a user can explore
         * @param {string} tenantId 
         * @param {boolean} [includeVariations] 
         * @param {number} [variation] 
         * @param {Array<number>} [variations] 
         * @param {string} [category] 
         * @param {boolean} [includeCombinations] 
         * @param {boolean} [isFallback] 
         * @param {boolean} [isFlexFallback] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCouponDefinitions: async (tenantId: string, includeVariations?: boolean, variation?: number, variations?: Array<number>, category?: string, includeCombinations?: boolean, isFallback?: boolean, isFlexFallback?: boolean, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('findCouponDefinitions', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/definition`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (includeVariations !== undefined) {
                localVarQueryParameter['includeVariations'] = includeVariations;
            }

            if (variation !== undefined) {
                localVarQueryParameter['variation'] = variation;
            }

            if (variations) {
                localVarQueryParameter['variations'] = variations;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (includeCombinations !== undefined) {
                localVarQueryParameter['includeCombinations'] = includeCombinations;
            }

            if (isFallback !== undefined) {
                localVarQueryParameter['isFallback'] = isFallback;
            }

            if (isFlexFallback !== undefined) {
                localVarQueryParameter['isFlexFallback'] = isFlexFallback;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all budget orders for all tenants
         * @param {GetAllBudgetOrdersBudgetOrderStatusEnum} [budgetOrderStatus] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBudgetOrders: async (budgetOrderStatus?: GetAllBudgetOrdersBudgetOrderStatusEnum, page?: number, pageSize?: number, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/coupons/budgetOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (budgetOrderStatus !== undefined) {
                localVarQueryParameter['budgetOrderStatus'] = budgetOrderStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all budget orders
         * @param {string} tenantId 
         * @param {GetBudgetOrdersBudgetOrderStatusEnum} [budgetOrderStatus] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudgetOrders: async (tenantId: string, budgetOrderStatus?: GetBudgetOrdersBudgetOrderStatusEnum, page?: number, pageSize?: number, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBudgetOrders', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/budgetOrders`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (budgetOrderStatus !== undefined) {
                localVarQueryParameter['budgetOrderStatus'] = budgetOrderStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single coupon definition
         * @param {string} tenantId 
         * @param {string} couponId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponDefinition: async (tenantId: string, couponId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponDefinition', 'tenantId', tenantId)
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('getCouponDefinition', 'couponId', couponId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/definition/{couponId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"couponId"}}`, encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a pkpass for apple/google wallet for orderId
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {boolean} [showPrimaryField] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponForWallet: async (tenantId: string, employeeId: string, couponOrderId: string, showPrimaryField?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponForWallet', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCouponForWallet', 'employeeId', employeeId)
            // verify required parameter 'couponOrderId' is not null or undefined
            assertParamExists('getCouponForWallet', 'couponOrderId', couponOrderId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders/{couponOrderId}/wallet`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponOrderId"}}`, encodeURIComponent(String(couponOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (showPrimaryField !== undefined) {
                localVarQueryParameter['showPrimaryField'] = showPrimaryField;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single coupon gift by id
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponGiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponGift: async (tenantId: string, employeeId: string, couponGiftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponGiftId' is not null or undefined
            assertParamExists('getCouponGift', 'couponGiftId', couponGiftId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/gifts/{couponGiftId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponGiftId"}}`, encodeURIComponent(String(couponGiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single coupon order by id
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {boolean} [showVoucherCodes] if true or undefined, (for backwards compatibility) voucher codes will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrder: async (tenantId: string, employeeId: string, couponOrderId: string, showVoucherCodes?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponOrder', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCouponOrder', 'employeeId', employeeId)
            // verify required parameter 'couponOrderId' is not null or undefined
            assertParamExists('getCouponOrder', 'couponOrderId', couponOrderId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders/{couponOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponOrderId"}}`, encodeURIComponent(String(couponOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (showVoucherCodes !== undefined) {
                localVarQueryParameter['showVoucherCodes'] = showVoucherCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupon orders for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrders: async (tenantId: string, employeeId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponOrders', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCouponOrders', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns the statistic for coupons of one tenant for one month
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {GetCouponOrdersStatisticStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrdersStatistic: async (tenantId: string, month?: string, status?: GetCouponOrdersStatisticStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponOrdersStatistic', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/orders/statistic`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns all custom gift occasions for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftOccasions: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getGiftOccasions', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/giftOccasions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary this will return the whole transaction history list
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {boolean} [includeCouponOrders] 
         * @param {boolean} [includeGiftOrders] 
         * @param {boolean} [includeBudgetOrders] 
         * @param {boolean} [includeIncentiveOrders] 
         * @param {boolean} [includeBudgetCorrections] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory: async (tenantId: string, month?: string, includeCouponOrders?: boolean, includeGiftOrders?: boolean, includeBudgetOrders?: boolean, includeIncentiveOrders?: boolean, includeBudgetCorrections?: boolean, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTransactionHistory', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/transactionHistory`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (includeCouponOrders !== undefined) {
                localVarQueryParameter['includeCouponOrders'] = includeCouponOrders;
            }

            if (includeGiftOrders !== undefined) {
                localVarQueryParameter['includeGiftOrders'] = includeGiftOrders;
            }

            if (includeBudgetOrders !== undefined) {
                localVarQueryParameter['includeBudgetOrders'] = includeBudgetOrders;
            }

            if (includeIncentiveOrders !== undefined) {
                localVarQueryParameter['includeIncentiveOrders'] = includeIncentiveOrders;
            }

            if (includeBudgetCorrections !== undefined) {
                localVarQueryParameter['includeBudgetCorrections'] = includeBudgetCorrections;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all orders for all tenants
         * @param {Array<CouponOrderStatus>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [isAutomatedOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllOrders: async (status?: Array<CouponOrderStatus>, filter?: string, isAutomatedOrder?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/coupons/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (isAutomatedOrder !== undefined) {
                localVarQueryParameter['isAutomatedOrder'] = isAutomatedOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupon gifts for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponGifts: async (tenantId: string, employeeId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listCouponGifts', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('listCouponGifts', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/gifts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupon gifts for tenant
         * @param {string} tenantId 
         * @param {ListTenantCouponGiftsGiftTypeEnum} [giftType] 
         * @param {string} [filter] 
         * @param {boolean} [isDelivered] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenantCouponGifts: async (tenantId: string, giftType?: ListTenantCouponGiftsGiftTypeEnum, filter?: string, isDelivered?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listTenantCouponGifts', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/gifts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (giftType !== undefined) {
                localVarQueryParameter['giftType'] = giftType;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (isDelivered !== undefined) {
                localVarQueryParameter['isDelivered'] = isDelivered;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a gift occasion for the tenant
         * @param {string} tenantId 
         * @param {SaveGiftOccasionOccasionEnum} occasion 
         * @param {SaveGiftOccasionDTO} saveGiftOccasionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGiftOccasion: async (tenantId: string, occasion: SaveGiftOccasionOccasionEnum, saveGiftOccasionDTO: SaveGiftOccasionDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('saveGiftOccasion', 'tenantId', tenantId)
            // verify required parameter 'occasion' is not null or undefined
            assertParamExists('saveGiftOccasion', 'occasion', occasion)
            // verify required parameter 'saveGiftOccasionDTO' is not null or undefined
            assertParamExists('saveGiftOccasion', 'saveGiftOccasionDTO', saveGiftOccasionDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/giftOccasions/{occasion}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"occasion"}}`, encodeURIComponent(String(occasion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveGiftOccasionDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sets coupon code to seen
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCouponCodeToSeen: async (tenantId: string, employeeId: string, couponOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('setCouponCodeToSeen', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('setCouponCodeToSeen', 'employeeId', employeeId)
            // verify required parameter 'couponOrderId' is not null or undefined
            assertParamExists('setCouponCodeToSeen', 'couponOrderId', couponOrderId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders/orderView/{couponOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponOrderId"}}`, encodeURIComponent(String(couponOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a coupon budget order
         * @param {string} tenantId 
         * @param {string} couponBudgetOrderId 
         * @param {UpdateCouponBudgetOrderDTO} updateCouponBudgetOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBudgetOrder: async (tenantId: string, couponBudgetOrderId: string, updateCouponBudgetOrderDTO: UpdateCouponBudgetOrderDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateBudgetOrder', 'tenantId', tenantId)
            // verify required parameter 'couponBudgetOrderId' is not null or undefined
            assertParamExists('updateBudgetOrder', 'couponBudgetOrderId', couponBudgetOrderId)
            // verify required parameter 'updateCouponBudgetOrderDTO' is not null or undefined
            assertParamExists('updateBudgetOrder', 'updateCouponBudgetOrderDTO', updateCouponBudgetOrderDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons/budgetOrders/{couponBudgetOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"couponBudgetOrderId"}}`, encodeURIComponent(String(couponBudgetOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponBudgetOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a coupon definition
         * @param {string} couponDefinitionId 
         * @param {UpdateCouponDefinitionDTO} updateCouponDefinitionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponDefinition: async (couponDefinitionId: string, updateCouponDefinitionDTO: UpdateCouponDefinitionDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponDefinitionId' is not null or undefined
            assertParamExists('updateCouponDefinition', 'couponDefinitionId', couponDefinitionId)
            // verify required parameter 'updateCouponDefinitionDTO' is not null or undefined
            assertParamExists('updateCouponDefinition', 'updateCouponDefinitionDTO', updateCouponDefinitionDTO)
            const localVarPath = `/benefits/coupons/definitions/{couponDefinitionId}`
                .replace(`{${"couponDefinitionId"}}`, encodeURIComponent(String(couponDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponDefinitionDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the default coupon of an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {UpdateEmployeeCouponDefaultDTO} updateEmployeeCouponDefaultDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponEmployeeDefault: async (tenantId: string, employeeId: string, updateEmployeeCouponDefaultDTO: UpdateEmployeeCouponDefaultDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateCouponEmployeeDefault', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateCouponEmployeeDefault', 'employeeId', employeeId)
            // verify required parameter 'updateEmployeeCouponDefaultDTO' is not null or undefined
            assertParamExists('updateCouponEmployeeDefault', 'updateEmployeeCouponDefaultDTO', updateEmployeeCouponDefaultDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/default`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeCouponDefaultDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponGiftId 
         * @param {UpdateCouponGiftDTO} updateCouponGiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponGift: async (tenantId: string, employeeId: string, couponGiftId: string, updateCouponGiftDTO: UpdateCouponGiftDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponGiftId' is not null or undefined
            assertParamExists('updateCouponGift', 'couponGiftId', couponGiftId)
            // verify required parameter 'updateCouponGiftDTO' is not null or undefined
            assertParamExists('updateCouponGift', 'updateCouponGiftDTO', updateCouponGiftDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/gifts/{couponGiftId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponGiftId"}}`, encodeURIComponent(String(couponGiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponGiftDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a coupon order for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {UpdateCouponOrderDTO} updateCouponOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponOrder: async (tenantId: string, employeeId: string, couponOrderId: string, updateCouponOrderDTO: UpdateCouponOrderDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateCouponOrder', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateCouponOrder', 'employeeId', employeeId)
            // verify required parameter 'couponOrderId' is not null or undefined
            assertParamExists('updateCouponOrder', 'couponOrderId', couponOrderId)
            // verify required parameter 'updateCouponOrderDTO' is not null or undefined
            assertParamExists('updateCouponOrder', 'updateCouponOrderDTO', updateCouponOrderDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons/orders/{couponOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponOrderId"}}`, encodeURIComponent(String(couponOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponsApi - functional programming interface
 * @export
 */
export const CouponsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary cancels a pending coupon order
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCouponOrder(tenantId: string, employeeId: string, couponOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCouponOrder(tenantId, employeeId, couponOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.cancelCouponOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary places a coupon budget order
         * @param {string} tenantId 
         * @param {CreateCouponBudgetOrderDTO} createCouponBudgetOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBudgetOrder(tenantId: string, createCouponBudgetOrderDTO: CreateCouponBudgetOrderDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBudgetOrder(tenantId, createCouponBudgetOrderDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.createBudgetOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary creates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateCouponGiftDTO} createCouponGiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCouponGift(tenantId: string, employeeId: string, createCouponGiftDTO: CreateCouponGiftDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCouponGift(tenantId, employeeId, createCouponGiftDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.createCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary creates a coupon order for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateCouponOrderDTO} createCouponOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCouponOrder(tenantId: string, employeeId: string, createCouponOrderDTO: CreateCouponOrderDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCouponOrder(tenantId, employeeId, createCouponOrderDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.createCouponOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deletes a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponGiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCouponGift(tenantId: string, employeeId: string, couponGiftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCouponGift(tenantId, employeeId, couponGiftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.deleteCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns the whole transaction history list in CSV format
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {boolean} [includeCouponOrders] 
         * @param {boolean} [includeGiftOrders] 
         * @param {boolean} [includeBudgetOrders] 
         * @param {boolean} [includeIncentiveOrders] 
         * @param {boolean} [includeBudgetCorrections] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTransactionHistory(tenantId: string, month?: string, includeCouponOrders?: boolean, includeGiftOrders?: boolean, includeBudgetOrders?: boolean, includeIncentiveOrders?: boolean, includeBudgetCorrections?: boolean, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTransactionHistory(tenantId, month, includeCouponOrders, includeGiftOrders, includeBudgetOrders, includeIncentiveOrders, includeBudgetCorrections, filter, withAggregations, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.exportTransactionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns all coupons in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAdminCouponDefinitions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCouponDefinitionListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAdminCouponDefinitions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.findAdminCouponDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns all coupons that a user can explore
         * @param {string} tenantId 
         * @param {boolean} [includeVariations] 
         * @param {number} [variation] 
         * @param {Array<number>} [variations] 
         * @param {string} [category] 
         * @param {boolean} [includeCombinations] 
         * @param {boolean} [isFallback] 
         * @param {boolean} [isFlexFallback] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCouponDefinitions(tenantId: string, includeVariations?: boolean, variation?: number, variations?: Array<number>, category?: string, includeCombinations?: boolean, isFallback?: boolean, isFlexFallback?: boolean, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponDefinitionListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCouponDefinitions(tenantId, includeVariations, variation, variations, category, includeCombinations, isFallback, isFlexFallback, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.findCouponDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all budget orders for all tenants
         * @param {GetAllBudgetOrdersBudgetOrderStatusEnum} [budgetOrderStatus] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBudgetOrders(budgetOrderStatus?: GetAllBudgetOrdersBudgetOrderStatusEnum, page?: number, pageSize?: number, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponBudgetOrderWithTenantListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBudgetOrders(budgetOrderStatus, page, pageSize, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getAllBudgetOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all budget orders
         * @param {string} tenantId 
         * @param {GetBudgetOrdersBudgetOrderStatusEnum} [budgetOrderStatus] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBudgetOrders(tenantId: string, budgetOrderStatus?: GetBudgetOrdersBudgetOrderStatusEnum, page?: number, pageSize?: number, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponBudgetOrdersDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBudgetOrders(tenantId, budgetOrderStatus, page, pageSize, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getBudgetOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single coupon definition
         * @param {string} tenantId 
         * @param {string} couponId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponDefinition(tenantId: string, couponId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponDefinitionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponDefinition(tenantId, couponId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a pkpass for apple/google wallet for orderId
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {boolean} [showPrimaryField] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponForWallet(tenantId: string, employeeId: string, couponOrderId: string, showPrimaryField?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponForWallet(tenantId, employeeId, couponOrderId, showPrimaryField, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponForWallet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single coupon gift by id
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponGiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponGift(tenantId: string, employeeId: string, couponGiftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponGiftDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponGift(tenantId, employeeId, couponGiftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single coupon order by id
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {boolean} [showVoucherCodes] if true or undefined, (for backwards compatibility) voucher codes will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponOrder(tenantId: string, employeeId: string, couponOrderId: string, showVoucherCodes?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponOrder(tenantId, employeeId, couponOrderId, showVoucherCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupon orders for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponOrders(tenantId: string, employeeId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponOrderListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponOrders(tenantId, employeeId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns the statistic for coupons of one tenant for one month
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {GetCouponOrdersStatisticStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponOrdersStatistic(tenantId: string, month?: string, status?: GetCouponOrdersStatisticStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponOrdersStatisticDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponOrdersStatistic(tenantId, month, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getCouponOrdersStatistic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns all custom gift occasions for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftOccasions(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponGiftOccasionListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftOccasions(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getGiftOccasions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary this will return the whole transaction history list
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {boolean} [includeCouponOrders] 
         * @param {boolean} [includeGiftOrders] 
         * @param {boolean} [includeBudgetOrders] 
         * @param {boolean} [includeIncentiveOrders] 
         * @param {boolean} [includeBudgetCorrections] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistory(tenantId: string, month?: string, includeCouponOrders?: boolean, includeGiftOrders?: boolean, includeBudgetOrders?: boolean, includeIncentiveOrders?: boolean, includeBudgetCorrections?: boolean, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponTransactionsHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistory(tenantId, month, includeCouponOrders, includeGiftOrders, includeBudgetOrders, includeIncentiveOrders, includeBudgetCorrections, filter, withAggregations, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.getTransactionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all orders for all tenants
         * @param {Array<CouponOrderStatus>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [isAutomatedOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllOrders(status?: Array<CouponOrderStatus>, filter?: string, isAutomatedOrder?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponOrderWithEmployeeListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllOrders(status, filter, isAutomatedOrder, page, pageSize, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.listAllOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupon gifts for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCouponGifts(tenantId: string, employeeId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponGiftListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCouponGifts(tenantId, employeeId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.listCouponGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupon gifts for tenant
         * @param {string} tenantId 
         * @param {ListTenantCouponGiftsGiftTypeEnum} [giftType] 
         * @param {string} [filter] 
         * @param {boolean} [isDelivered] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTenantCouponGifts(tenantId: string, giftType?: ListTenantCouponGiftsGiftTypeEnum, filter?: string, isDelivered?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponGiftWithEmployeeListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTenantCouponGifts(tenantId, giftType, filter, isDelivered, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.listTenantCouponGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updates a gift occasion for the tenant
         * @param {string} tenantId 
         * @param {SaveGiftOccasionOccasionEnum} occasion 
         * @param {SaveGiftOccasionDTO} saveGiftOccasionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGiftOccasion(tenantId: string, occasion: SaveGiftOccasionOccasionEnum, saveGiftOccasionDTO: SaveGiftOccasionDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGiftOccasion(tenantId, occasion, saveGiftOccasionDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.saveGiftOccasion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sets coupon code to seen
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCouponCodeToSeen(tenantId: string, employeeId: string, couponOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCouponCodeToSeen(tenantId, employeeId, couponOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.setCouponCodeToSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updates a coupon budget order
         * @param {string} tenantId 
         * @param {string} couponBudgetOrderId 
         * @param {UpdateCouponBudgetOrderDTO} updateCouponBudgetOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBudgetOrder(tenantId: string, couponBudgetOrderId: string, updateCouponBudgetOrderDTO: UpdateCouponBudgetOrderDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBudgetOrder(tenantId, couponBudgetOrderId, updateCouponBudgetOrderDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.updateBudgetOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a coupon definition
         * @param {string} couponDefinitionId 
         * @param {UpdateCouponDefinitionDTO} updateCouponDefinitionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponDefinition(couponDefinitionId: string, updateCouponDefinitionDTO: UpdateCouponDefinitionDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponDefinition(couponDefinitionId, updateCouponDefinitionDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.updateCouponDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the default coupon of an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {UpdateEmployeeCouponDefaultDTO} updateEmployeeCouponDefaultDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponEmployeeDefault(tenantId: string, employeeId: string, updateEmployeeCouponDefaultDTO: UpdateEmployeeCouponDefaultDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponEmployeeDefault(tenantId, employeeId, updateEmployeeCouponDefaultDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.updateCouponEmployeeDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponGiftId 
         * @param {UpdateCouponGiftDTO} updateCouponGiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponGift(tenantId: string, employeeId: string, couponGiftId: string, updateCouponGiftDTO: UpdateCouponGiftDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponGift(tenantId, employeeId, couponGiftId, updateCouponGiftDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.updateCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updates a coupon order for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponOrderId 
         * @param {UpdateCouponOrderDTO} updateCouponOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponOrder(tenantId: string, employeeId: string, couponOrderId: string, updateCouponOrderDTO: UpdateCouponOrderDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponOrder(tenantId, employeeId, couponOrderId, updateCouponOrderDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.updateCouponOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouponsApi - factory interface
 * @export
 */
export const CouponsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponsApiFp(configuration)
    return {
        /**
         * 
         * @summary cancels a pending coupon order
         * @param {CouponsApiCancelCouponOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCouponOrder(requestParameters: CouponsApiCancelCouponOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary places a coupon budget order
         * @param {CouponsApiCreateBudgetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBudgetOrder(requestParameters: CouponsApiCreateBudgetOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdentifierDTO> {
            return localVarFp.createBudgetOrder(requestParameters.tenantId, requestParameters.createCouponBudgetOrderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates a coupon gift for employee
         * @param {CouponsApiCreateCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouponGift(requestParameters: CouponsApiCreateCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdentifierDTO> {
            return localVarFp.createCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createCouponGiftDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates a coupon order for employee
         * @param {CouponsApiCreateCouponOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouponOrder(requestParameters: CouponsApiCreateCouponOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdentifierDTO> {
            return localVarFp.createCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createCouponOrderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deletes a coupon gift for employee
         * @param {CouponsApiDeleteCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouponGift(requestParameters: CouponsApiDeleteCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponGiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns the whole transaction history list in CSV format
         * @param {CouponsApiExportTransactionHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTransactionHistory(requestParameters: CouponsApiExportTransactionHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportTransactionHistory(requestParameters.tenantId, requestParameters.month, requestParameters.includeCouponOrders, requestParameters.includeGiftOrders, requestParameters.includeBudgetOrders, requestParameters.includeIncentiveOrders, requestParameters.includeBudgetCorrections, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns all coupons in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdminCouponDefinitions(options?: RawAxiosRequestConfig): AxiosPromise<AdminCouponDefinitionListDTO> {
            return localVarFp.findAdminCouponDefinitions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns all coupons that a user can explore
         * @param {CouponsApiFindCouponDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCouponDefinitions(requestParameters: CouponsApiFindCouponDefinitionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponDefinitionListDTO> {
            return localVarFp.findCouponDefinitions(requestParameters.tenantId, requestParameters.includeVariations, requestParameters.variation, requestParameters.variations, requestParameters.category, requestParameters.includeCombinations, requestParameters.isFallback, requestParameters.isFlexFallback, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all budget orders for all tenants
         * @param {CouponsApiGetAllBudgetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBudgetOrders(requestParameters: CouponsApiGetAllBudgetOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CouponBudgetOrderWithTenantListDTO> {
            return localVarFp.getAllBudgetOrders(requestParameters.budgetOrderStatus, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all budget orders
         * @param {CouponsApiGetBudgetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudgetOrders(requestParameters: CouponsApiGetBudgetOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponBudgetOrdersDTO> {
            return localVarFp.getBudgetOrders(requestParameters.tenantId, requestParameters.budgetOrderStatus, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single coupon definition
         * @param {CouponsApiGetCouponDefinitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponDefinition(requestParameters: CouponsApiGetCouponDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponDefinitionDTO> {
            return localVarFp.getCouponDefinition(requestParameters.tenantId, requestParameters.couponId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a pkpass for apple/google wallet for orderId
         * @param {CouponsApiGetCouponForWalletRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponForWallet(requestParameters: CouponsApiGetCouponForWalletRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCouponForWallet(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, requestParameters.showPrimaryField, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single coupon gift by id
         * @param {CouponsApiGetCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponGift(requestParameters: CouponsApiGetCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponGiftDTO> {
            return localVarFp.getCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponGiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single coupon order by id
         * @param {CouponsApiGetCouponOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrder(requestParameters: CouponsApiGetCouponOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponOrderDTO> {
            return localVarFp.getCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, requestParameters.showVoucherCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupon orders for employee
         * @param {CouponsApiGetCouponOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrders(requestParameters: CouponsApiGetCouponOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponOrderListDTO> {
            return localVarFp.getCouponOrders(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns the statistic for coupons of one tenant for one month
         * @param {CouponsApiGetCouponOrdersStatisticRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrdersStatistic(requestParameters: CouponsApiGetCouponOrdersStatisticRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponOrdersStatisticDTO> {
            return localVarFp.getCouponOrdersStatistic(requestParameters.tenantId, requestParameters.month, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns all custom gift occasions for the tenant
         * @param {CouponsApiGetGiftOccasionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftOccasions(requestParameters: CouponsApiGetGiftOccasionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponGiftOccasionListDTO> {
            return localVarFp.getGiftOccasions(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary this will return the whole transaction history list
         * @param {CouponsApiGetTransactionHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory(requestParameters: CouponsApiGetTransactionHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponTransactionsHistoryDTO> {
            return localVarFp.getTransactionHistory(requestParameters.tenantId, requestParameters.month, requestParameters.includeCouponOrders, requestParameters.includeGiftOrders, requestParameters.includeBudgetOrders, requestParameters.includeIncentiveOrders, requestParameters.includeBudgetCorrections, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all orders for all tenants
         * @param {CouponsApiListAllOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllOrders(requestParameters: CouponsApiListAllOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CouponOrderWithEmployeeListDTO> {
            return localVarFp.listAllOrders(requestParameters.status, requestParameters.filter, requestParameters.isAutomatedOrder, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupon gifts for employee
         * @param {CouponsApiListCouponGiftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponGifts(requestParameters: CouponsApiListCouponGiftsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponGiftListDTO> {
            return localVarFp.listCouponGifts(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupon gifts for tenant
         * @param {CouponsApiListTenantCouponGiftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenantCouponGifts(requestParameters: CouponsApiListTenantCouponGiftsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponGiftWithEmployeeListDTO> {
            return localVarFp.listTenantCouponGifts(requestParameters.tenantId, requestParameters.giftType, requestParameters.filter, requestParameters.isDelivered, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a gift occasion for the tenant
         * @param {CouponsApiSaveGiftOccasionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGiftOccasion(requestParameters: CouponsApiSaveGiftOccasionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveGiftOccasion(requestParameters.tenantId, requestParameters.occasion, requestParameters.saveGiftOccasionDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sets coupon code to seen
         * @param {CouponsApiSetCouponCodeToSeenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCouponCodeToSeen(requestParameters: CouponsApiSetCouponCodeToSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCouponCodeToSeen(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a coupon budget order
         * @param {CouponsApiUpdateBudgetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBudgetOrder(requestParameters: CouponsApiUpdateBudgetOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBudgetOrder(requestParameters.tenantId, requestParameters.couponBudgetOrderId, requestParameters.updateCouponBudgetOrderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a coupon definition
         * @param {CouponsApiUpdateCouponDefinitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponDefinition(requestParameters: CouponsApiUpdateCouponDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCouponDefinition(requestParameters.couponDefinitionId, requestParameters.updateCouponDefinitionDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the default coupon of an employee
         * @param {CouponsApiUpdateCouponEmployeeDefaultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponEmployeeDefault(requestParameters: CouponsApiUpdateCouponEmployeeDefaultRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCouponEmployeeDefault(requestParameters.tenantId, requestParameters.employeeId, requestParameters.updateEmployeeCouponDefaultDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a coupon gift for employee
         * @param {CouponsApiUpdateCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponGift(requestParameters: CouponsApiUpdateCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponGiftId, requestParameters.updateCouponGiftDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a coupon order for employee
         * @param {CouponsApiUpdateCouponOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponOrder(requestParameters: CouponsApiUpdateCouponOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, requestParameters.updateCouponOrderDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelCouponOrder operation in CouponsApi.
 * @export
 * @interface CouponsApiCancelCouponOrderRequest
 */
export interface CouponsApiCancelCouponOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiCancelCouponOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiCancelCouponOrder
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiCancelCouponOrder
     */
    readonly couponOrderId: string
}

/**
 * Request parameters for createBudgetOrder operation in CouponsApi.
 * @export
 * @interface CouponsApiCreateBudgetOrderRequest
 */
export interface CouponsApiCreateBudgetOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiCreateBudgetOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {CreateCouponBudgetOrderDTO}
     * @memberof CouponsApiCreateBudgetOrder
     */
    readonly createCouponBudgetOrderDTO: CreateCouponBudgetOrderDTO
}

/**
 * Request parameters for createCouponGift operation in CouponsApi.
 * @export
 * @interface CouponsApiCreateCouponGiftRequest
 */
export interface CouponsApiCreateCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiCreateCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiCreateCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {CreateCouponGiftDTO}
     * @memberof CouponsApiCreateCouponGift
     */
    readonly createCouponGiftDTO: CreateCouponGiftDTO
}

/**
 * Request parameters for createCouponOrder operation in CouponsApi.
 * @export
 * @interface CouponsApiCreateCouponOrderRequest
 */
export interface CouponsApiCreateCouponOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiCreateCouponOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiCreateCouponOrder
     */
    readonly employeeId: string

    /**
     * 
     * @type {CreateCouponOrderDTO}
     * @memberof CouponsApiCreateCouponOrder
     */
    readonly createCouponOrderDTO: CreateCouponOrderDTO
}

/**
 * Request parameters for deleteCouponGift operation in CouponsApi.
 * @export
 * @interface CouponsApiDeleteCouponGiftRequest
 */
export interface CouponsApiDeleteCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiDeleteCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiDeleteCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiDeleteCouponGift
     */
    readonly couponGiftId: string
}

/**
 * Request parameters for exportTransactionHistory operation in CouponsApi.
 * @export
 * @interface CouponsApiExportTransactionHistoryRequest
 */
export interface CouponsApiExportTransactionHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly month?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly includeCouponOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly includeGiftOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly includeBudgetOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly includeIncentiveOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly includeBudgetCorrections?: boolean

    /**
     * 
     * @type {string}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiExportTransactionHistory
     */
    readonly pageSize?: number
}

/**
 * Request parameters for findCouponDefinitions operation in CouponsApi.
 * @export
 * @interface CouponsApiFindCouponDefinitionsRequest
 */
export interface CouponsApiFindCouponDefinitionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly includeVariations?: boolean

    /**
     * 
     * @type {number}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly variation?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly variations?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly category?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly includeCombinations?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly isFallback?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly isFlexFallback?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiFindCouponDefinitions
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for getAllBudgetOrders operation in CouponsApi.
 * @export
 * @interface CouponsApiGetAllBudgetOrdersRequest
 */
export interface CouponsApiGetAllBudgetOrdersRequest {
    /**
     * 
     * @type {'ORDERED' | 'COMPLETED' | 'CANCELLED'}
     * @memberof CouponsApiGetAllBudgetOrders
     */
    readonly budgetOrderStatus?: GetAllBudgetOrdersBudgetOrderStatusEnum

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetAllBudgetOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetAllBudgetOrders
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiGetAllBudgetOrders
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for getBudgetOrders operation in CouponsApi.
 * @export
 * @interface CouponsApiGetBudgetOrdersRequest
 */
export interface CouponsApiGetBudgetOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetBudgetOrders
     */
    readonly tenantId: string

    /**
     * 
     * @type {'ORDERED' | 'COMPLETED' | 'CANCELLED'}
     * @memberof CouponsApiGetBudgetOrders
     */
    readonly budgetOrderStatus?: GetBudgetOrdersBudgetOrderStatusEnum

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetBudgetOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetBudgetOrders
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiGetBudgetOrders
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for getCouponDefinition operation in CouponsApi.
 * @export
 * @interface CouponsApiGetCouponDefinitionRequest
 */
export interface CouponsApiGetCouponDefinitionRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponDefinition
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponDefinition
     */
    readonly couponId: string
}

/**
 * Request parameters for getCouponForWallet operation in CouponsApi.
 * @export
 * @interface CouponsApiGetCouponForWalletRequest
 */
export interface CouponsApiGetCouponForWalletRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponForWallet
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponForWallet
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponForWallet
     */
    readonly couponOrderId: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetCouponForWallet
     */
    readonly showPrimaryField?: boolean
}

/**
 * Request parameters for getCouponGift operation in CouponsApi.
 * @export
 * @interface CouponsApiGetCouponGiftRequest
 */
export interface CouponsApiGetCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponGift
     */
    readonly couponGiftId: string
}

/**
 * Request parameters for getCouponOrder operation in CouponsApi.
 * @export
 * @interface CouponsApiGetCouponOrderRequest
 */
export interface CouponsApiGetCouponOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrder
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrder
     */
    readonly couponOrderId: string

    /**
     * if true or undefined, (for backwards compatibility) voucher codes will be returned
     * @type {boolean}
     * @memberof CouponsApiGetCouponOrder
     */
    readonly showVoucherCodes?: boolean
}

/**
 * Request parameters for getCouponOrders operation in CouponsApi.
 * @export
 * @interface CouponsApiGetCouponOrdersRequest
 */
export interface CouponsApiGetCouponOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrders
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrders
     */
    readonly employeeId: string

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetCouponOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetCouponOrders
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getCouponOrdersStatistic operation in CouponsApi.
 * @export
 * @interface CouponsApiGetCouponOrdersStatisticRequest
 */
export interface CouponsApiGetCouponOrdersStatisticRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrdersStatistic
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetCouponOrdersStatistic
     */
    readonly month?: string

    /**
     * 
     * @type {'PAYMENT_DUE' | 'PENDING' | 'ORDERED' | 'COMPLETED' | 'ERROR' | 'PAYMENT_FAILED'}
     * @memberof CouponsApiGetCouponOrdersStatistic
     */
    readonly status?: GetCouponOrdersStatisticStatusEnum
}

/**
 * Request parameters for getGiftOccasions operation in CouponsApi.
 * @export
 * @interface CouponsApiGetGiftOccasionsRequest
 */
export interface CouponsApiGetGiftOccasionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetGiftOccasions
     */
    readonly tenantId: string
}

/**
 * Request parameters for getTransactionHistory operation in CouponsApi.
 * @export
 * @interface CouponsApiGetTransactionHistoryRequest
 */
export interface CouponsApiGetTransactionHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly month?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly includeCouponOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly includeGiftOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly includeBudgetOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly includeIncentiveOrders?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly includeBudgetCorrections?: boolean

    /**
     * 
     * @type {string}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiGetTransactionHistory
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listAllOrders operation in CouponsApi.
 * @export
 * @interface CouponsApiListAllOrdersRequest
 */
export interface CouponsApiListAllOrdersRequest {
    /**
     * 
     * @type {Array<CouponOrderStatus>}
     * @memberof CouponsApiListAllOrders
     */
    readonly status?: Array<CouponOrderStatus>

    /**
     * 
     * @type {string}
     * @memberof CouponsApiListAllOrders
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiListAllOrders
     */
    readonly isAutomatedOrder?: boolean

    /**
     * 
     * @type {number}
     * @memberof CouponsApiListAllOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiListAllOrders
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiListAllOrders
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for listCouponGifts operation in CouponsApi.
 * @export
 * @interface CouponsApiListCouponGiftsRequest
 */
export interface CouponsApiListCouponGiftsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiListCouponGifts
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiListCouponGifts
     */
    readonly employeeId: string

    /**
     * 
     * @type {number}
     * @memberof CouponsApiListCouponGifts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiListCouponGifts
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listTenantCouponGifts operation in CouponsApi.
 * @export
 * @interface CouponsApiListTenantCouponGiftsRequest
 */
export interface CouponsApiListTenantCouponGiftsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly tenantId: string

    /**
     * 
     * @type {'GIFT' | 'INCENTIVE'}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly giftType?: ListTenantCouponGiftsGiftTypeEnum

    /**
     * 
     * @type {string}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly isDelivered?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsApiListTenantCouponGifts
     */
    readonly pageSize?: number
}

/**
 * Request parameters for saveGiftOccasion operation in CouponsApi.
 * @export
 * @interface CouponsApiSaveGiftOccasionRequest
 */
export interface CouponsApiSaveGiftOccasionRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiSaveGiftOccasion
     */
    readonly tenantId: string

    /**
     * 
     * @type {'BIRTHDAY' | 'SAINTS_DAY' | 'CHILD_BIRTH' | 'CHILD_BAPTISM' | 'CHILD_COMMUNION' | 'CHILD_CONFIRMATION_CATH' | 'CHILD_CONFIRMATION_PROT' | 'WEDDING' | 'WEDDING_SILVER' | 'WEDDING_GOLD' | 'PASSED_EXAM' | 'COMPANY_ANNIVERSARY' | 'ACHIEVEMENT' | 'WORK_PERFORMANCE' | 'COMMITMENT' | 'PROPOSAL' | 'RECRUITMENT' | 'ATTENDANCE' | 'SIGNING_BONUS' | 'PROFIT_SHARING' | 'OTHER'}
     * @memberof CouponsApiSaveGiftOccasion
     */
    readonly occasion: SaveGiftOccasionOccasionEnum

    /**
     * 
     * @type {SaveGiftOccasionDTO}
     * @memberof CouponsApiSaveGiftOccasion
     */
    readonly saveGiftOccasionDTO: SaveGiftOccasionDTO
}

/**
 * Request parameters for setCouponCodeToSeen operation in CouponsApi.
 * @export
 * @interface CouponsApiSetCouponCodeToSeenRequest
 */
export interface CouponsApiSetCouponCodeToSeenRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiSetCouponCodeToSeen
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiSetCouponCodeToSeen
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiSetCouponCodeToSeen
     */
    readonly couponOrderId: string
}

/**
 * Request parameters for updateBudgetOrder operation in CouponsApi.
 * @export
 * @interface CouponsApiUpdateBudgetOrderRequest
 */
export interface CouponsApiUpdateBudgetOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateBudgetOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateBudgetOrder
     */
    readonly couponBudgetOrderId: string

    /**
     * 
     * @type {UpdateCouponBudgetOrderDTO}
     * @memberof CouponsApiUpdateBudgetOrder
     */
    readonly updateCouponBudgetOrderDTO: UpdateCouponBudgetOrderDTO
}

/**
 * Request parameters for updateCouponDefinition operation in CouponsApi.
 * @export
 * @interface CouponsApiUpdateCouponDefinitionRequest
 */
export interface CouponsApiUpdateCouponDefinitionRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponDefinition
     */
    readonly couponDefinitionId: string

    /**
     * 
     * @type {UpdateCouponDefinitionDTO}
     * @memberof CouponsApiUpdateCouponDefinition
     */
    readonly updateCouponDefinitionDTO: UpdateCouponDefinitionDTO
}

/**
 * Request parameters for updateCouponEmployeeDefault operation in CouponsApi.
 * @export
 * @interface CouponsApiUpdateCouponEmployeeDefaultRequest
 */
export interface CouponsApiUpdateCouponEmployeeDefaultRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponEmployeeDefault
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponEmployeeDefault
     */
    readonly employeeId: string

    /**
     * 
     * @type {UpdateEmployeeCouponDefaultDTO}
     * @memberof CouponsApiUpdateCouponEmployeeDefault
     */
    readonly updateEmployeeCouponDefaultDTO: UpdateEmployeeCouponDefaultDTO
}

/**
 * Request parameters for updateCouponGift operation in CouponsApi.
 * @export
 * @interface CouponsApiUpdateCouponGiftRequest
 */
export interface CouponsApiUpdateCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponGift
     */
    readonly couponGiftId: string

    /**
     * 
     * @type {UpdateCouponGiftDTO}
     * @memberof CouponsApiUpdateCouponGift
     */
    readonly updateCouponGiftDTO: UpdateCouponGiftDTO
}

/**
 * Request parameters for updateCouponOrder operation in CouponsApi.
 * @export
 * @interface CouponsApiUpdateCouponOrderRequest
 */
export interface CouponsApiUpdateCouponOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponOrder
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsApiUpdateCouponOrder
     */
    readonly couponOrderId: string

    /**
     * 
     * @type {UpdateCouponOrderDTO}
     * @memberof CouponsApiUpdateCouponOrder
     */
    readonly updateCouponOrderDTO: UpdateCouponOrderDTO
}

/**
 * CouponsApi - object-oriented interface
 * @export
 * @class CouponsApi
 * @extends {BaseAPI}
 */
export class CouponsApi extends BaseAPI {
    /**
     * 
     * @summary cancels a pending coupon order
     * @param {CouponsApiCancelCouponOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public cancelCouponOrder(requestParameters: CouponsApiCancelCouponOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).cancelCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary places a coupon budget order
     * @param {CouponsApiCreateBudgetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public createBudgetOrder(requestParameters: CouponsApiCreateBudgetOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).createBudgetOrder(requestParameters.tenantId, requestParameters.createCouponBudgetOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates a coupon gift for employee
     * @param {CouponsApiCreateCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public createCouponGift(requestParameters: CouponsApiCreateCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).createCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createCouponGiftDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates a coupon order for employee
     * @param {CouponsApiCreateCouponOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public createCouponOrder(requestParameters: CouponsApiCreateCouponOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).createCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createCouponOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deletes a coupon gift for employee
     * @param {CouponsApiDeleteCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public deleteCouponGift(requestParameters: CouponsApiDeleteCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).deleteCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponGiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns the whole transaction history list in CSV format
     * @param {CouponsApiExportTransactionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public exportTransactionHistory(requestParameters: CouponsApiExportTransactionHistoryRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).exportTransactionHistory(requestParameters.tenantId, requestParameters.month, requestParameters.includeCouponOrders, requestParameters.includeGiftOrders, requestParameters.includeBudgetOrders, requestParameters.includeIncentiveOrders, requestParameters.includeBudgetCorrections, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns all coupons in the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public findAdminCouponDefinitions(options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).findAdminCouponDefinitions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns all coupons that a user can explore
     * @param {CouponsApiFindCouponDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public findCouponDefinitions(requestParameters: CouponsApiFindCouponDefinitionsRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).findCouponDefinitions(requestParameters.tenantId, requestParameters.includeVariations, requestParameters.variation, requestParameters.variations, requestParameters.category, requestParameters.includeCombinations, requestParameters.isFallback, requestParameters.isFlexFallback, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all budget orders for all tenants
     * @param {CouponsApiGetAllBudgetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getAllBudgetOrders(requestParameters: CouponsApiGetAllBudgetOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getAllBudgetOrders(requestParameters.budgetOrderStatus, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all budget orders
     * @param {CouponsApiGetBudgetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getBudgetOrders(requestParameters: CouponsApiGetBudgetOrdersRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getBudgetOrders(requestParameters.tenantId, requestParameters.budgetOrderStatus, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single coupon definition
     * @param {CouponsApiGetCouponDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getCouponDefinition(requestParameters: CouponsApiGetCouponDefinitionRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getCouponDefinition(requestParameters.tenantId, requestParameters.couponId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a pkpass for apple/google wallet for orderId
     * @param {CouponsApiGetCouponForWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getCouponForWallet(requestParameters: CouponsApiGetCouponForWalletRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getCouponForWallet(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, requestParameters.showPrimaryField, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single coupon gift by id
     * @param {CouponsApiGetCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getCouponGift(requestParameters: CouponsApiGetCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponGiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single coupon order by id
     * @param {CouponsApiGetCouponOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getCouponOrder(requestParameters: CouponsApiGetCouponOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, requestParameters.showVoucherCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupon orders for employee
     * @param {CouponsApiGetCouponOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getCouponOrders(requestParameters: CouponsApiGetCouponOrdersRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getCouponOrders(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns the statistic for coupons of one tenant for one month
     * @param {CouponsApiGetCouponOrdersStatisticRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getCouponOrdersStatistic(requestParameters: CouponsApiGetCouponOrdersStatisticRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getCouponOrdersStatistic(requestParameters.tenantId, requestParameters.month, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns all custom gift occasions for the tenant
     * @param {CouponsApiGetGiftOccasionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getGiftOccasions(requestParameters: CouponsApiGetGiftOccasionsRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getGiftOccasions(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary this will return the whole transaction history list
     * @param {CouponsApiGetTransactionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getTransactionHistory(requestParameters: CouponsApiGetTransactionHistoryRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getTransactionHistory(requestParameters.tenantId, requestParameters.month, requestParameters.includeCouponOrders, requestParameters.includeGiftOrders, requestParameters.includeBudgetOrders, requestParameters.includeIncentiveOrders, requestParameters.includeBudgetCorrections, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all orders for all tenants
     * @param {CouponsApiListAllOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public listAllOrders(requestParameters: CouponsApiListAllOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).listAllOrders(requestParameters.status, requestParameters.filter, requestParameters.isAutomatedOrder, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupon gifts for employee
     * @param {CouponsApiListCouponGiftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public listCouponGifts(requestParameters: CouponsApiListCouponGiftsRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).listCouponGifts(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupon gifts for tenant
     * @param {CouponsApiListTenantCouponGiftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public listTenantCouponGifts(requestParameters: CouponsApiListTenantCouponGiftsRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).listTenantCouponGifts(requestParameters.tenantId, requestParameters.giftType, requestParameters.filter, requestParameters.isDelivered, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a gift occasion for the tenant
     * @param {CouponsApiSaveGiftOccasionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public saveGiftOccasion(requestParameters: CouponsApiSaveGiftOccasionRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).saveGiftOccasion(requestParameters.tenantId, requestParameters.occasion, requestParameters.saveGiftOccasionDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sets coupon code to seen
     * @param {CouponsApiSetCouponCodeToSeenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public setCouponCodeToSeen(requestParameters: CouponsApiSetCouponCodeToSeenRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).setCouponCodeToSeen(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a coupon budget order
     * @param {CouponsApiUpdateBudgetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public updateBudgetOrder(requestParameters: CouponsApiUpdateBudgetOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).updateBudgetOrder(requestParameters.tenantId, requestParameters.couponBudgetOrderId, requestParameters.updateCouponBudgetOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a coupon definition
     * @param {CouponsApiUpdateCouponDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public updateCouponDefinition(requestParameters: CouponsApiUpdateCouponDefinitionRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).updateCouponDefinition(requestParameters.couponDefinitionId, requestParameters.updateCouponDefinitionDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the default coupon of an employee
     * @param {CouponsApiUpdateCouponEmployeeDefaultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public updateCouponEmployeeDefault(requestParameters: CouponsApiUpdateCouponEmployeeDefaultRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).updateCouponEmployeeDefault(requestParameters.tenantId, requestParameters.employeeId, requestParameters.updateEmployeeCouponDefaultDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a coupon gift for employee
     * @param {CouponsApiUpdateCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public updateCouponGift(requestParameters: CouponsApiUpdateCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).updateCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponGiftId, requestParameters.updateCouponGiftDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a coupon order for employee
     * @param {CouponsApiUpdateCouponOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public updateCouponOrder(requestParameters: CouponsApiUpdateCouponOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).updateCouponOrder(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponOrderId, requestParameters.updateCouponOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllBudgetOrdersBudgetOrderStatusEnum = {
    Ordered: 'ORDERED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;
export type GetAllBudgetOrdersBudgetOrderStatusEnum = typeof GetAllBudgetOrdersBudgetOrderStatusEnum[keyof typeof GetAllBudgetOrdersBudgetOrderStatusEnum];
/**
 * @export
 */
export const GetBudgetOrdersBudgetOrderStatusEnum = {
    Ordered: 'ORDERED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;
export type GetBudgetOrdersBudgetOrderStatusEnum = typeof GetBudgetOrdersBudgetOrderStatusEnum[keyof typeof GetBudgetOrdersBudgetOrderStatusEnum];
/**
 * @export
 */
export const GetCouponOrdersStatisticStatusEnum = {
    PaymentDue: 'PAYMENT_DUE',
    Pending: 'PENDING',
    Ordered: 'ORDERED',
    Completed: 'COMPLETED',
    Error: 'ERROR',
    PaymentFailed: 'PAYMENT_FAILED'
} as const;
export type GetCouponOrdersStatisticStatusEnum = typeof GetCouponOrdersStatisticStatusEnum[keyof typeof GetCouponOrdersStatisticStatusEnum];
/**
 * @export
 */
export const ListTenantCouponGiftsGiftTypeEnum = {
    Gift: 'GIFT',
    Incentive: 'INCENTIVE'
} as const;
export type ListTenantCouponGiftsGiftTypeEnum = typeof ListTenantCouponGiftsGiftTypeEnum[keyof typeof ListTenantCouponGiftsGiftTypeEnum];
/**
 * @export
 */
export const SaveGiftOccasionOccasionEnum = {
    Birthday: 'BIRTHDAY',
    SaintsDay: 'SAINTS_DAY',
    ChildBirth: 'CHILD_BIRTH',
    ChildBaptism: 'CHILD_BAPTISM',
    ChildCommunion: 'CHILD_COMMUNION',
    ChildConfirmationCath: 'CHILD_CONFIRMATION_CATH',
    ChildConfirmationProt: 'CHILD_CONFIRMATION_PROT',
    Wedding: 'WEDDING',
    WeddingSilver: 'WEDDING_SILVER',
    WeddingGold: 'WEDDING_GOLD',
    PassedExam: 'PASSED_EXAM',
    CompanyAnniversary: 'COMPANY_ANNIVERSARY',
    Achievement: 'ACHIEVEMENT',
    WorkPerformance: 'WORK_PERFORMANCE',
    Commitment: 'COMMITMENT',
    Proposal: 'PROPOSAL',
    Recruitment: 'RECRUITMENT',
    Attendance: 'ATTENDANCE',
    SigningBonus: 'SIGNING_BONUS',
    ProfitSharing: 'PROFIT_SHARING',
    Other: 'OTHER'
} as const;
export type SaveGiftOccasionOccasionEnum = typeof SaveGiftOccasionOccasionEnum[keyof typeof SaveGiftOccasionOccasionEnum];
